import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

type SpinnerSize = 'sm' | 'md' | 'xl' | '2xl';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sky-spinner',
  template: ` <div
    style="border-top-color:transparent"
    class="border-solid animate-spin rounded-full border-sky-blue"
    [ngClass]="sizeClass"
  ></div>`,
})
export class SpinnerComponent implements OnChanges {
  @Input() public color: string = 'indigo';
  @Input() public size: SpinnerSize = 'sm';

  public sizeClass = 'border-2 h-4 w-4';

  private readonly _sizeClassMap = new Map<SpinnerSize, string>([
    ['sm', 'border-2 h-4 w-4'],
    ['md', 'border-2 h-6 w-6'],
    ['xl', 'border-4 h-8 w-8'],
    ['2xl', 'border-4 h-12 w-12'],
  ]);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.size) {
      this.sizeClass = this._sizeClassMap.get(this.size) || 'sm';
    }
  }

  public updateSize() {
    this.sizeClass = this._sizeClassMap.get(this.size) || 'sm';
  }
}
